<template>
<div id="dash" v-if="render">
  <SmartWidgetGrid 
    :layout.sync="grid" 
    @container-resized="onContainerResize" 
    @resized="onResize"
    :margin="[10,10]"
    :rowHeight="rowHeight"
    :resizable="true"
  >
    <smart-widget v-bind:key="item.args.s" v-for="item in w"
      :slot="item.args.s" 
      :simple="item.args.title == null" 
      :title="item.args.title" 
      :subTitle="item.args.subtitle"
      :fullscreen="item.args.fullscreen"
      :padding="[0,0]"
      shadow='never'
      :resizable="true"
      :loading="item.args.loading"
      
      @before-fullscreen="beforeFullScreen($event, item)"
    >
    <!-- @on-fullscreen="onFullScreen($event, item)" -->
      <DashItem :item="item">
      </DashItem>
    </smart-widget> 
  </SmartWidgetGrid>
</div>
</template>

<script>
// shadow='hover' - smart-widget option
import DashItem from './DashItem'
import { sync } from 'vuex-pathify'
import _ from 'lodash'
import { debounce } from 'vue-debounce'
export default {
  props: {
    grid: {
      type: Array,
      required: true
    },
    comps: {
      type: Array,
      required: true
    },
    updated: {
      type: Boolean,
      required: false,
      default: false
    },
    size : {
      type: Number,
      required: false,
      default: 10
    },
    cols : {
      type: Number,
      required: false,
      default: 12
    },
    height : {
      type: Number,
      required: false,
      default: 40
    }
  },
    components: {
      DashItem
    },

    data () {
			var self = this;
      return {
				recalculate: false,
				render: false,
				widgetdata: [],
				keepLayout: {},
				rowHeight: 40,
				griddebouncer: true,
				heightdebouncer: true,
				numRows: 13,
			}
				// fullScreen: false
    },
    computed: {
      fullScreen: sync('misc/fullScreen'),
      w () {
        return this.widgetdata
      },
    },
    watch: {
      height: {
        immediate: true,
        handler: function (val) {
          // console.log('Height changed to: ', val)
          this.setRowHeight (val, this.numRows)
          // this.rowHeight = (val - 200 ) / 13
          // this.render = false;
          // this.$nextTick().then(() => {
          //   this.render = true;
          // })
        }
      },
      rowHeight (val) {
        this.render = false;
        this.$nextTick().then(() => {
          this.render = true;
        })
      },
      grid: {
        handler: function(val) {
          this.recalculate = true
        },
        deep: true
      },
      recalculate (val) {
        if (!val) return
        var self = this
        debounce(() => {
          var max_y = self.grid.reduce((max, i) => {
            return (i.y + i.h > max) ? i.y + i.h : max
          }, 0)
          this.numRows = max_y
          this.setRowHeight(this.height, max_y)
          self.recalculate = false
        }, 1000)()
      },
      // grid: {
      //   handler: function(newVal) {
      // this.$emit('update:layout', newVal)
      // this.$emit('update:grid', newVal)
      // this.$emit('update:layoutUpdate', true)
      //   deep:true,
      //   immediate: true
      // },
      comps: {
        handler: function (newVal) {
          this.widgetdata = _.cloneDeep(newVal)
        },
        immediate: true,
        deep: true
      }
    },
    
    methods: {
      beforeFullScreen(event, item) {
        // console.log("fullscreen event", event, item)
        this.fullScreen = event
      },
      onFullScreen(event, item) {},
      onResize(val) {
        // console.log('on resize: ', val)
      },
      onContainerResize(val) {
        // console.log('Containert resized: ', val)
      },
      setRowHeight (height, numrows) {
        this.rowHeight = (height - 220 - numrows - (numrows -13) * 10) / numrows
        // console.log('New Row Height = ', this.rowHeight)
      }
    },
    mounted () {
      this.fullScreen = false;
      this.widgetdata = this.comps.slice()
    }
}
</script>

<style >

</style>
